import { Grid } from '@mui/material';
import { ReportType } from 'generated/graphql';
import { useGetList } from 'react-admin';

import { AccountsChart } from './AccountsChart';
import { ClientStatsCard } from './ClientStatsCard';
import { ProductsStatusChart } from './ProductsStatusChart';
import { ProductsTypeChart } from './ProductsTypeChart';
import { ReportStatsCard } from './ReportStatsCard';
import { useListProducts } from './useListProducts';
import { UserInvitationStatsCard } from './UserInvitationStatsCard';

/**
 * Počet pozvánok
 * Prijaté pozvánky
 * Počet klientov s pripojenými účtami
 * Graf - účty - pripojené/expirované
 * Klienti s produktami/ klienti s aktívnymi produktami
 * Graf produkty podľa typu
 */

export const FinancialAdvisorDashboard: React.FC = () => {
  const { data: accounts, isLoading: isLoadingAccounts } = useGetList('Account', {
    pagination: { page: 1, perPage: 10000 },
    sort: { field: 'creationTimestamp', order: 'DESC' },
  });

  const { data: clients, isLoading: isLoadingClients } = useGetList('Client', {
    pagination: { page: 1, perPage: 10000 },
    sort: { field: 'creationTimestamp', order: 'DESC' },
  });

  const { data: userInvitations, isLoading: isLoadingUserInvitations } = useGetList('UserInvitation', {
    pagination: { page: 1, perPage: 10000 },
    sort: { field: 'creationTimestamp', order: 'DESC' },
  });

  const { data: products, isLoading: isLoadingProducts } = useListProducts();

  const { data: reports, isLoading: isLoadingReports } = useGetList('Report', {
    pagination: { page: 1, perPage: 10000 },
    sort: { field: 'creationTimestamp', order: 'DESC' },
  });

  return (
    <Grid container mt={2} spacing={2}>
      <Grid item md={4} sm={12}>
        <UserInvitationStatsCard isLoading={isLoadingUserInvitations} userInvitations={userInvitations} />
      </Grid>
      <Grid item md={4} sm={12}>
        <ClientStatsCard clients={clients} isLoading={isLoadingClients} />
      </Grid>
      <Grid item md={4} sm={12}>
        <ReportStatsCard isLoading={isLoadingReports} reportType={ReportType.Finoptio} reports={reports} />
      </Grid>
      <Grid item md={4} sm={12}>
        <AccountsChart accounts={accounts} isLoading={isLoadingAccounts} />
      </Grid>
      <Grid item md={4} sm={12}>
        <ProductsStatusChart isLoading={isLoadingProducts} products={products} />
      </Grid>
      <Grid item md={4} sm={12}>
        <ProductsTypeChart isLoading={isLoadingProducts} products={products} />
      </Grid>
    </Grid>
  );
};
